import { render, staticRenderFns } from "./AmountsModal.vue?vue&type=template&id=52ed7682&scoped=true&"
import script from "./AmountsModal.vue?vue&type=script&lang=js&"
export * from "./AmountsModal.vue?vue&type=script&lang=js&"
import style0 from "./AmountsModal.vue?vue&type=style&index=0&id=52ed7682&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed7682",
  null
  
)

export default component.exports